import { Loader2Icon } from 'lucide-react'
import { useState } from 'react'

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/lemmala-design-system/card/card'
import { Modal } from '@/components/lemmala-design-system/modal/modal'
import { Markdown } from '@/components/shared/markdown/markdown'

type JiraPreviewIssueModalProps = {
  issues: {
    summary: string
    description: string
  }[]
  isLoading: boolean
}

export function useJiraPreviewIssueModal({ issues, isLoading }: JiraPreviewIssueModalProps) {
  const [isOpen, setIsOpen] = useState(false)
  const showModal = () => setIsOpen(true)
  const closeModal = async () => setIsOpen(false)

  const renderModal = () => (
    <Modal
      open={isOpen}
      onOk={closeModal}
      onCancel={closeModal}
      title='Preview'
      primaryButtonText='OK'
      showCancelButton={false}
      className='flex w-1/2 flex-col overflow-hidden' // Height set by div
    >
      <div className='h-[65vh] overflow-y-auto'>
        {isLoading ? (
          <Loader2Icon className='m-auto size-4 animate-spin' />
        ) : (
          issues.map((issue) => (
            <Card
              key={issue.summary}
              className='mb-4 rounded-lg border border-main-border-default bg-main-background-muted p-4'
            >
              <CardHeader>
                <CardTitle>{issue.summary}</CardTitle>
              </CardHeader>
              <CardContent className='prose prose-sm max-w-none px-2 pb-2'>
                <Markdown>{issue.description}</Markdown>
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </Modal>
  )

  return { showModal, renderModal }
}
